/* app/js/src/components/calendar/expandable/calendar-expandable-red-line-indicator/calendar-expandable-red-line-indicator.component.scss */
.red-line {
  position: absolute;
  width: 100%;
  height: 1px;
  top: -1px;
  z-index: 1000;
  background-color: #ff0000;
}
/*# sourceMappingURL=calendar-expandable-red-line-indicator.component.css.map */
